<!-- Filters bar -->
<div class="flex flex-col gap-2" [class.mb-5]="viewType() === 'list'" [class.mb-9]="viewType() === 'grid'">
  <span class="text-sm mb-1" data-testid="campaign-details-creators-filters-title">{{
    'pages.campaignDetails.creators.filters.title' | translate
  }}</span>

  <div class="flex items-center justify-between gap-3">
    <div class="flex items-center gap-3 flex-1">
      @if (!exportMode()) {
        <app-campaign-details-deliverables-filter-select
          class="w-[252px]"
          [emptyLabel]="invitationFilterEmptyLabel()"
          [loading]="loading()"
          [options]="invitationOptions()"
          [selectedValues]="invitationFilter()"
          [showBulkActions]="false"
          [showSearch]="false"
          (selectionChanged)="invitationFilter.set($event)"
        />

        <app-campaign-details-deliverables-filter-select
          class="w-[252px]"
          [emptyLabel]="briefingFilterEmptyLabel()"
          [loading]="loading()"
          [options]="briefingOptions()"
          [selectedValues]="briefingFilter()"
          [showBulkActions]="false"
          [showSearch]="false"
          (selectionChanged)="briefingFilter.set($event)"
        />
      }

      <app-campaign-details-deliverables-filter-select
        class="w-[252px]"
        [emptyLabel]="statusFilterEmptyLabel()"
        [loading]="loading()"
        [options]="statusOptions()"
        [selectedValues]="statusFilter()"
        [showBulkActions]="false"
        [showSearch]="false"
        (selectionChanged)="statusFilter.set($event)"
      />
    </div>

    <!-- View toggle buttons -->
    <div class="flex items-center gap-1">
      <button
        mat-flat-button
        color="secondary"
        type="button"
        class="!min-w-0 !px-[3px] mat-tiny-button"
        [class.!bg-shikenso-pink-base]="viewType() === 'list'"
        [attr.aria-label]="'pages.campaignDetails.creators.listView' | translate"
        (click)="onToggleView('list')"
      >
        <app-icon src="/icons/list.svg" alt="List view" [size]="16" />
      </button>

      <button
        mat-flat-button
        color="secondary"
        type="button"
        class="!min-w-0 !px-[3px] mat-tiny-button"
        [class.!bg-shikenso-pink-base]="viewType() === 'grid'"
        [attr.aria-label]="'pages.campaignDetails.creators.gridView' | translate"
        (click)="onToggleView('grid')"
      >
        <app-icon src="/icons/layout-grid.svg" alt="Grid view" [size]="16" />
      </button>
    </div>
  </div>
</div>

@if (viewType() === 'grid') {
  <app-campaign-details-creators-grid
    [creators]="displayCreators()"
    [campaign]="campaign()"
    [creatorCampaignExports]="creatorCampaignExports()"
    [loading]="loading()"
    [creatorBriefingMode]="creatorBriefingMode()"
    [exportMode]="exportMode()"
    [invitedCreatorIds]="invitedCreatorIds()"
    (deepLinkClicked)="onDeepLinkClicked($event)"
  />
} @else {
  <app-campaign-details-creators-table
    [creators]="displayCreators()"
    [campaign]="campaign()"
    [creatorCampaignExports]="creatorCampaignExports()"
    [loading]="loading()"
    [creatorBriefingMode]="creatorBriefingMode()"
    [exportMode]="exportMode()"
    [invitedCreatorIds]="invitedCreatorIds()"
    (deepLinkClicked)="onDeepLinkClicked($event)"
  />
}
